/**
 * REFUSALS IN PLAIN WORDS. The payment-types endpoints refuse with a machine
 * code (`error`) — `apiService` keeps it as `err.code` and the service's own
 * sentence as `err.serverMessage`. A code we know becomes a sentence an
 * operator can act on; anything else falls back to the server's sentence, then
 * to the caller's fallback. Never a bare code on screen.
 */
export const PAYMENT_ERROR_TEXT: Record<string, string> = {
  debit_required_with_surcharge:
    'Debit has to stay on while this till charges a surcharge — the customer must be able to pick debit and pay no fee. Turn the surcharge off first.',
  override_active:
    'An emergency override is on for this till, so its payment types are locked until the override is turned off.',
  tips_capability_disabled:
    'Card tips are not allowed at this location yet — switch on the card tips grant for the location first.',
  cash_tips_capability_disabled:
    'Cash tips are not allowed at this location yet — switch on the cash tips grant for the location first.',
  gateway_config_not_found:
    'This location has no card processing set up yet, so its tip and surcharge settings cannot be saved. Set up card processing for the location first.',
  surcharge_not_available:
    'Surcharge is not approved for this location — it needs the surcharge grant and a signed agreement first.',
  MUTEX_VIOLATION: 'Only one card payment type can be on at a time.',
  /* SUNMI card setup (sunmi-card-setup.md §3) */
  DEBIT_NEEDS_PIN_READER:
    'No reader on this register can take PIN, so debit (and surcharge, which needs debit) cannot be on. Add a PIN-capable reader on the Terminal (EMV/SoftPOS) tab first.',
  CARD_SETUP_MANAGED:
    'This till\'s card readers are set on its Terminal (EMV/SoftPOS) tab. Change them there.',
};

/** The code a thrown API error carries, wherever it ended up. */
export function errorCodeOf(e: any): string | null {
  const candidates = [e?.code, e?.error, e?.data?.error, e?.message];
  for (const c of candidates) if (typeof c === 'string' && PAYMENT_ERROR_TEXT[c]) return c;
  const msg = String(e?.message || '');
  return Object.keys(PAYMENT_ERROR_TEXT).find((k) => msg.includes(k)) || null;
}

export function explainPaymentError(e: any, fallback: string): string {
  const code = errorCodeOf(e);
  if (code) return PAYMENT_ERROR_TEXT[code];
  return e?.serverMessage || e?.message || fallback;
}
